import type { CatalogFieldState } from "@/lib/api/generated/casedb";
import { ExtractedValueProblemReasonEnum } from "@/lib/api/generated/casedb";
import type { ReviewDecision } from "../model/caseReview";
import { tooLongValueNote } from "../constants/caseReviewLabels";

/**
 * The line under a field whose extracted value was read but not stored (issue #400), or undefined.
 *
 * <p>Only a value too long for its field gets one. Once the reviewer decides the field, the line
 * goes: the field then holds the reviewer's value or is left empty on purpose.
 */
export function extractedValueNote(state: CatalogFieldState | undefined,
                                   decision: ReviewDecision | undefined): string | undefined {
  const problem = state?.extracted_value_problem;
  if (decision || problem?.reason !== ExtractedValueProblemReasonEnum.TooLong
    || problem.length === undefined || problem.limit === undefined) return undefined;
  return tooLongValueNote(problem.length, problem.limit);
}
